// @flow

import typeToReducer from 'type-to-reducer'

import { COMMIT_P2P_STATS, RESET_P2P_STATS } from '../actions'

export type P2PTotals = {
  total: number,
  http: number,
  p2p: number,
  upload: number,
}

export type P2PStatsState = {
  bound: boolean,
  peerCount: number,
  totals: P2PTotals,
}

const initialState: P2PStatsState = {
  bound: false,
  peerCount: 0,
  totals: {
    total: 0,
    http: 0,
    p2p: 0,
    upload: 0,
  },
}

const p2pStats: P2PStatsState = typeToReducer(
  {
    [COMMIT_P2P_STATS]: (state, { payload }) => ({
      bound: payload.bound,
      peerCount: payload.peerCount,
      totals: payload.totals,
    }),
    [RESET_P2P_STATS]: () => initialState,
  },
  initialState,
)

export { p2pStats }
